import React from "react";
import { Checkbox } from "@mui/material";
import { Control, Controller, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { CustomLabel } from "../input/CustomLabel";
import { InputErrorMessage } from "../input/InputErrorMessage";

type CheckBoxWithoutValidationProps = {
  usarValidacaoParaFormulario: false;
};

type CheckBoxWithValidationProps = {
  usarValidacaoParaFormulario: true;
  /**Nome do atributo que será usado no formulario para realizar as validacoes*/
  name: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
};
type CheckBoxProps = {
  id: string;
  label?: string;
  checked?: boolean;
  defaultValue?: boolean;
  disabled?: boolean;
  value?: any;
  onChange?: (checked: boolean) => void;
} & (CheckBoxWithoutValidationProps | CheckBoxWithValidationProps);

export const CheckBox: React.FC<CheckBoxProps> = (props) => {
  const renderCheckBoxSemValidacao = () => {
    return (
      <Checkbox
        checked={props.checked}
        disabled={props.disabled}
        onChange={(e, checked) => props.onChange && props.onChange(checked)}
        size="small"
      />
    );
  };

  const renderCheckBoxComValidacao = () => {
    if (props.usarValidacaoParaFormulario) {
      return (
        <Controller
          name={props.name}
          control={props.control}
          defaultValue={props.defaultValue}
          render={({ field, fieldState }) => (
            <>
              {props.label && (
                <CustomLabel possuiErro={fieldState.error != null}>{props.label}</CustomLabel>
              )}
              <Checkbox
                checked={props.checked}
                disabled={props.disabled}
                onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                  field.onChange(checked);
                  props.setValue(props.name, checked);
                  props.onChange && props.onChange(checked);
                }}
                size="small"
              />
              {fieldState.error && (
                <InputErrorMessage>{fieldState.error.message}</InputErrorMessage>
              )}
            </>
          )}
        />
      );
    }
  };

  return (
    <>
      {!props.usarValidacaoParaFormulario && renderCheckBoxSemValidacao()}
      {props.usarValidacaoParaFormulario && renderCheckBoxComValidacao()}
    </>
  );
};
